var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImagePhoto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7892_109133)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.56836,
    y: 3.96289,
    width: 43.75,
    height: 43.75,
    rx: 21.875,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2808 21.124C24.2605 21.124 21.812 23.5725 21.812 26.5928C21.812 29.6131 24.2605 32.0615 27.2808 32.0615C30.3011 32.0615 32.7495 29.6131 32.7495 26.5928C32.7495 23.5725 30.3011 21.124 27.2808 21.124Z",
    fill: "#FF6E57"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4078 12.4777C24.6902 12.4089 25.9815 12.374 27.2808 12.374C28.5801 12.374 29.8713 12.4089 31.1537 12.4777C32.5648 12.5535 33.822 13.3309 34.5552 14.5059L35.7528 16.4251C36.1015 16.9838 36.6935 17.3634 37.3717 17.4598C37.9338 17.5397 38.4937 17.6261 39.0514 17.7191C41.1395 18.067 42.5933 19.8959 42.5933 21.9611V34.249C42.5933 36.6653 40.6345 38.624 38.2183 38.624H16.3433C13.927 38.624 11.9683 36.6653 11.9683 34.249V21.9611C11.9683 19.8959 13.422 18.067 15.5101 17.7191C16.0679 17.6261 16.6278 17.5397 17.1898 17.4598C17.868 17.3634 18.4601 16.9838 18.8087 16.4251L20.0063 14.5059C20.7396 13.3309 21.9967 12.5535 23.4078 12.4777ZM19.6245 26.5928C19.6245 22.3643 23.0523 18.9365 27.2808 18.9365C31.5092 18.9365 34.937 22.3643 34.937 26.5928C34.937 30.8212 31.5092 34.249 27.2808 34.249C23.0523 34.249 19.6245 30.8212 19.6245 26.5928ZM37.1245 24.4053C37.7286 24.4053 38.2183 23.9156 38.2183 23.3115C38.2183 22.7075 37.7286 22.2178 37.1245 22.2178C36.5205 22.2178 36.0308 22.7075 36.0308 23.3115C36.0308 23.9156 36.5205 24.4053 37.1245 24.4053Z",
    fill: "#FF6E57"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7892_109133",
    x: 0.520282,
    y: 0.597506,
    width: 53.8462,
    height: 53.8462,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.68269
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.52404
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7892_109133"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7892_109133",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePhoto);
export default __webpack_public_path__ + "static/media/image_photo.b8d049a20f0b0e49cb8407ea97c88a28.svg";
export { ForwardRef as ReactComponent };